import Param from "../../../param";
import Util from "../../libs/util";
import LoadVideoTexture from "./loadVideoTexture";
import Force from "../util/force";

const param = new Param();
const util = new Util();
let force = new Force();

export default class MakeVideo {
    constructor(src,thum){


        this.src = src;
        this.thumSrc = thum;

        this.video;
        this.videoTexture;
        this.videoThumTexture = new THREE.TextureLoader().load(this.thumSrc);
        this.mesh;

        this.uniforms;

        this.maskTex ={
            x : [],
            y : ""
        };

    }
    init(){

        for(let i=0; i<param.webgl.mainvisual.mask.srcTrans.length; i++){
            this.maskTex.x[i] = new THREE.TextureLoader().load(param.webgl.mainvisual.mask.srcTrans[i]);
        }
        this.maskTex.y = new THREE.TextureLoader().load(param.webgl.mainvisual.mask.srcY);

        if(!Useragnt.ie){
            this.video = new LoadVideoTexture(this.src);
            this.videoTexture = this.video.init()[1];
            this.videoTexture.needsUpdate = true;
        }else{
            this.video = new THREE.TextureLoader().load(this.thumSrc);
        }



        // let _geo = new THREE.PlaneBufferGeometry(1,1);
        let _geo = new THREE.PlaneGeometry(1, 1, 32, 32);
        _geo.verticesNeedUpdate=true;

        this.uniforms = {
            // texture   :{value:this.videoTexture},
            texture   :{value:!Useragnt.ie?this.videoThumTexture:this.video},
            tMask   :{value:this.maskTex.x[Math.floor(util.random(0,2))]},
            tMaskY   :{value:this.maskTex.y},
            strength   :{value:400.0},
            offsetX   :{value:0.0},
            offsetY   :{value:0.0},
            offMask   :{value:true},
            offMaskY   :{value:true},
            opacity   :{value:1.0},
            contrast   :{value:0.0},
            darkness   :{value:0.1},
            acceleration   :{value:0.01},
            colorFilter   :{value:false},
            start : {type: "f", value: 1.0},
            // noiseMulti : {type: "f", value: 0.5},
            noiseMulti : {type: "f", value: 0.0},
            time : {type: "f", value: 1},
            resolution : { type: "v2", value: new THREE.Vector2() },
            mouse : { type: "v2", value: new THREE.Vector2() }
        }
        if(!Useragnt.ie){
            this.uniforms.resolution.x = this.video.video.videoWidth;
            this.uniforms.resolution.y = Useragnt.mobile ? this.video.video.videoHeight*1.1:this.video.video.videoHeight;
        }else{
            this.uniforms.resolution.x = window.innerWidth;
            this.uniforms.resolution.y = window.innerHeight;
        }

        // this.uniforms.noiseMulti.value = 0.5;

        let _mat = new THREE.ShaderMaterial({
            vertexShader: !Useragnt.mobile? require('../../../../shader/mainvisual.vert'):require('../../../../shader/sp/mainvisual.vert'),
            fragmentShader: !Useragnt.mobile? require('../../../../shader/mainvisual_mask.frag'):require('../../../../shader/sp/mainvisual_mask.frag'),
            // fragmentShader: require('../../../../shader/subText-posteffect.frag'),
            transparent   :true,
            // side:THREE.DoubleSide,
            uniforms:this.uniforms
        });

        this.mesh = new THREE.Mesh( _geo,_mat );

        // this.mesh.position.x = window.innerWidth/4;
        return this.mesh;

    }
    resize(){

    }
}